import { useElapsedTime } from 'use-elapsed-time';

export function FormattedElapsedTime() {
  const { elapsedTime } = useElapsedTime({ isPlaying: true, updateInterval: 1, startAt: 0 });

  const days = Math.floor(elapsedTime / (60 * 60 * 24));
  const hours = Math.floor(elapsedTime / (60 * 60)) % 24;
  const minutes = Math.floor(elapsedTime / 60) % 60;
  const seconds = elapsedTime % 60;

  let output = `${getPaddedFace(minutes)}:${getPaddedFace(seconds)}`;

  if (days > 0) {
    output = `${getPaddedFace(days)}:${getPaddedFace(hours)}:${output}`;
  } else if (hours > 0) {
    output = `${getPaddedFace(hours)}:${output}`;
  }

  return output;
}

function getPaddedFace(faceValue: number) {
  if (faceValue < 10) {
    return `0${faceValue}`;
  }

  return faceValue;
}
